import { createSignal } from 'solid-js';
import {createContext,useContext} from 'solid-js';

const LayoutContext = createContext();


export function LayoutProvider(P)
{
	const [layout,setLayout] = createSignal(false);

	return (
		<LayoutContext.Provider value={{layout,setLayout}}>
			{P.children}
		</LayoutContext.Provider>
	);
}

export function useLayout(): {layout:()=>boolean,setLayout:(value:boolean)=>void}
{
	return useContext(LayoutContext);
}
